import type { StreamingConfiguration } from '@sgme/signalr';
import type { ISGWTConnectConfiguration } from '@sgwt/connect-core';
import type { AccessibilityCompliance } from '@sgwt/sgwt-widgets-react';

import type { SupportedLocale } from 'locales/locales';

import type { AppEnvironment } from './app.shared.ts';
import { mockedEnvs } from './app.shared.ts';

export interface AppConfiguration {
  env: AppEnvironment;
  api_uri: string;
  unauthorized_redirect_uri: string;
  sgconnect: ISGWTConnectConfiguration;
  streaming: StreamingConfiguration;
  matomo: MatomoConfiguration;
  allowCustomImpersonation: boolean;
  availableLanguages: SupportedLocale[];
  accessibilityCompliance: AccessibilityCompliance;
  accessibilityLink: string;
}

export const appConfig: AppConfiguration = globalThis.sgmeConfiguration;

export const isProductionEnv = appConfig.env === 'production';
export const isHomologationEnv = !isProductionEnv;

export const isUnderSgConnectMock = mockedEnvs.has(appConfig.env);

export const applicationPrefix = 'MM';
export const applicationId = 'sgmarkets-mm';
export const producerCode = 'sgm_money_markets';
export const helpCenterId = 'mm-help-center';
export const appSgIamResourceName = 'SG Markets Money Markets';
export const appName = 'Money Markets';

export function getAppEnvName(): string {
  return appConfig.env === 'production' ? 'Production' : 'Homologation';
}

type MatomoConfiguration = { baseUrl: string; siteId: string };
